module.exports = __webpack_public_path__ + "img/b-1.2ea8d6d.png";